import { Component, OnInit, effect, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';

import { BackendService } from '@shared/backend.service';
import { CredentialsService } from '@app/auth';
import { ProjectService } from '@app/shell/header/header.project.service';
import { UserProfile, ProjectSummary, ProjectDetails } from '@shared/api_interfaces';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomeComponent implements OnInit {
  constructor(
    private backendService: BackendService,
    public credentialsService: CredentialsService,
    public projectService: ProjectService,
    private router: Router
  ) {
    effect(() => {
      this.loadProjectSummaries();
    });
  }

  refreshText = '';
  isLoading = false;
  userProfile: UserProfile | null = null;
  projectSummaries: ProjectSummary[] = [];

  ngOnInit() {
    console.log('home.component ngInit');
    this.loadUserProfile();
  }

  private loadUserProfile() {
    // Extract user info from credentials
    // For prototype, we'll use the email and derive a name
    // In production, this would come from a backend API
    if (this.credentialsService.credentials()) {
      const email = this.credentialsService.email();
      const username = this.credentialsService.username();
      const company = this.credentialsService.company();
      const name = this.credentialsService.name();

      // For prototype: derive name from username/email
      // In production, this would be fetched from user profile API
      this.userProfile = {
        name: name,
        company: company,
        email: email,
      };
    }
  }

  private loadProjectSummaries() {
    const projects = this.projectService.projectDetails();

    if (projects && projects.length > 0) {
      this.projectSummaries = projects.map((project: ProjectDetails) => {
        // Count samples by analysis type
        const totalSamples = Object.keys(project.samples).length;
        let flairrSamples = project.flairr_samples.length;
        let captureSamples = project.genomic_samples.length;

        return {
          project_id: project.project_id,
          project_name: project.project_data.project_name,
          project_description: project.project_data.project_description,
          total_samples: totalSamples,
          capture_samples: captureSamples,
          flairr_samples: flairrSamples,
        };
      });
    }
  }

  public navigateToSamples(projectId: string) {
    this.projectService.setCurrentProject(projectId);
    this.router.navigate(['/download']);
  }

  public navigateToCaptureAnalysis(projectId: string) {
    this.projectService.setCurrentProject(projectId);
    this.router.navigate(['/gene-summary']);
  }

  public navigateToFlairrAnalysis(projectId: string) {
    this.projectService.setCurrentProject(projectId);
    this.router.navigate(['/flairr-summary']);
  }
}
